"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledColorBox = exports.SingleColorBox = exports.ColorBox = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _utils = require("./utils");
const _excluded = ["color", "isSelected", "onClick"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const StyledColorBox = _styledComponents.default.div`
    position: relative;
    width: 12px;
    height: 12px;
    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: center;

    background-color: ${({
  backgroundColor
}) => backgroundColor};

    ${({
  isSelected
}) => isSelected && (0, _styledComponents.css)`
        &:after {
            content: '';
            position: absolute;
            top: -3px;
            left: -3px;
            border: 2px solid black;
            border-radius: 2px;
            width: 18px;
            height: 18px;
            z-index: 1;
        }

        &:before {
            content: '';
            position: absolute;
            top: -2px;
            left: -2px;
            border: 2px solid white;
            border-radius: 2px;
            width: 16px;
            height: 16px;

            z-index: 1;
        }
    `}
`;
exports.StyledColorBox = StyledColorBox;
const ColorBox = _ref => {
  let {
      color,
      isSelected,
      onClick
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(StyledColorBox, _extends({
    isSelected: isSelected,
    backgroundColor: !_utils.RGBColor.isAutoColor(color) ? color.toCSS() : 'transparent',
    title: `RGBA: ${color.r}, ${color.g}, ${color.b}, ${color.a} | HEX: ${color.toHEX()}`,
    onClick: e => onClick(color, e)
  }, rest));
};
exports.ColorBox = ColorBox;
ColorBox.propTypes = {
  color: _propTypes.default.instanceOf(_utils.RGBColor).isRequired,
  onClick: _propTypes.default.func,
  isSelected: _propTypes.default.bool
};
const SingleColorBox = (0, _styledComponents.default)(ColorBox)`
    margin: 0 3px;
    outline: 1px solid var(--border-color);
`;
exports.SingleColorBox = SingleColorBox;